import React from "react";
import PropTypes from "prop-types";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import  SsoRedirect  from "./components/ssoRedirect/index.js";
import { VendorDashboard } from "./components/vendorDashboard/index.js";
import configSettings from "./config.js";



const vpToken = localStorage.getItem("vpToken");
const fName = localStorage.getItem("fName");
const lName = localStorage.getItem("lName");
const vendorName = localStorage.getItem("vendorName");


const setAuth = () => {
  let vpTokenFromLocalStorage  = (!vpToken || vpToken === "null")  ? configSettings.jwtToken : vpToken;
  let fnameFromLocalStorage  = (!fName || fName === 'undefined' || fName === 'null')  ? configSettings.firstName : fName;
  let lnameFromLocalStorage  = (!lName || lName === 'undefined' ||  lName === 'null')  ? configSettings.lastName : lName;
  let vendorNameFromLocalStorage  = (!vendorName || vendorName === 'undefined' ||  vendorName === 'null')  ? configSettings.vendorName : vendorName;

  if(!vpToken || vpToken === "null")
  localStorage.setItem("vpToken", vpTokenFromLocalStorage);
  if(!fName || fName === "null")
  localStorage.setItem("fName", fnameFromLocalStorage);
  if(!lName || lName === "null")
  localStorage.setItem("lName", lnameFromLocalStorage);
  if(!vendorName || vendorName === "null")
  localStorage.setItem("vendorName", vendorNameFromLocalStorage);
};

const isUserAuthorized = () => {
  if(vpToken === null || vpToken == "null" || typeof vpToken === 'undefined')
  setAuth();

  const vpToken = localStorage.getItem("vpToken");

  return (vpToken !== null && vpToken !== "null" && typeof vpToken !== 'undefined') ||
  window.location.href.includes("local.vendorportal.com")

}


const ProtectedRoute = ({ component: Component, ...rest }) => {
  if(location.pathname !== '/Vendor')
  localStorage.setItem('redirectUrl',location.pathname+location.search);

  return (
    <Route
      exact
      {...rest}
      render={(props) => {
        return isUserAuthorized() ?  <Component {...props} /> : <Redirect to="/ssoLogin" />;
      }}
    />
  );
};
ProtectedRoute.propTypes = {
  component: PropTypes.func,
};



function App() {
  let history = createBrowserHistory();

  return (
    <Router history={history} >
      <div>
        <Switch>
          <Route exact path="/ssoLogin" component={SsoRedirect}  />
          <ProtectedRoute  path="/Vendor" component={VendorDashboard} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
